import { createStore } from "vuex"
import authModule from "./modules/auth"
import defaultsModule from "./modules/defaults"
import usersModule from "./modules/users"
import todolistModule from "./modules/todolist"
import stationsModule from "./modules/stations"
// import pictureModule from "./modules/picture"

const store = createStore({
  modules: {
    auth: authModule,
    defaults: defaultsModule,
    users: usersModule,
    todolist: todolistModule,
    stations: stationsModule,
    // picture: pictureModule,
  },
})

export default store
